import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function offerListHasErrored(bool) {
  return {
    type: 'OFFER_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function offerListIsLoading(bool) {
  return {
    type: 'OFFER_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function offerListFetchDataSuccess(offerList) {
  return {
    type: 'OFFER_LIST_FETCH_DATA_SUCCESS',
    offerList,
  };
}

export function newOfferSaveSuccess(bool, offer) {
  return {
    type: 'NEW_OFFER_SAVE_SUCCESS',
    isSavedSuccess: bool,
    offer: offer,
  };
}

export function newOfferSaveErrored(bool, message) {
  return {
    type: 'NEW_OFFER_SAVE_ERRORED',
    isSaveErrored: bool,
    message: message,
  };
}

export function newOfferIsSaving(bool) {
  return {
    type: 'NEW_OFFER_IS_SAVING',
    isSaving: bool,
  };
}

export function offerDetailsHasErrored(bool) {
  return {
    type: 'OFFER_DETAILS_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function offerDetailsIsLoading(bool) {
  return {
    type: 'OFFER_DETAILS_IS_LOADING',
    isLoading: bool,
  };
}

export function offerDetailsFetchDataSuccess(offerDetails) {
  return {
    type: 'OFFER_DETAILS_FETCH_DATA_SUCCESS',
    offerDetails,
  };
}

export function offerRuleFetchDataSuccess(ruleList) {
  return {
    type: 'OFFER_RULE_FETCH_DATA_SUCCESS',
    ruleList,
  };
}

export function addNewOfferRuleDataSuccess(offerRule) {
  return {
    type: 'ADD_OFFER_RULE_DATA_SUCCESS',
    offerRule,
  };
}

export function updateOfferRuleDataSuccess(offerRule) {
  return {
    type: 'UPDATE_OFFER_RULE_DATA_SUCCESS',
    offerRule,
  };
}

export function removeOfferRuleDataSuccess(offerRule) {
  return {
    type: 'REMOVE_OFFER_RULE_DATA_SUCCESS',
    offerRule,
  };
}

export function offerRuleIsSaving(bool) {
  return {
    type: 'OFFER_RULE_IS_SAVING',
    isLoading: bool,
  };
}

export function offerRuleIsSaveErrored(bool) {
  return {
    type: 'OFFER_RULE_IS_SAVE_ERRORED',
    isLoading: bool,
  };
}

export function redirectToOfferListPage(bool) {
  return {
    type: 'REDIRECT_TO_OFFER_LIST',
    doRedirectToOfferListPage: bool,
  };
}

export function supplierItemListHasErrored(bool) {
  return {
    type: 'SUPPLIER_ITEM_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function supplierItemListIsLoading(bool) {
  return {
    type: 'SUPPLIER_ITEM_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function supplierItemListFetchDataSuccess(supplierIetmList) {
  return {
    type: 'SUPPLIER_ITEM_LIST_FETCH_DATA_SUCCESS',
    supplierIetmList,
  };
}

export function activateOfferDataSuccess(bool) {
  return {
    type: 'ACTIVATE_OFFER_DATA_SUCCESS',
    hasActivated: bool,
  };
}

export function activateOfferSaving(bool) {
  return {
    type: 'OFFER_IS_ACTIVATING',
    isLoading: bool,
  };
}

export function activateOfferErrored(bool) {
  return {
    type: 'ACTIVATE_OFFER_ERRORED',
    hasErrored: bool,
  };
}

function buildQueryString(source, startDate, endDate, searchCriteria, status) {
  let queryString = '';

  if (source) queryString += '&source=' + source;
  queryString += '&startDate=' + startDate;
  queryString += '&endDate=' + endDate;
  if (searchCriteria) queryString += '&searchCriteria=' + searchCriteria;
  if (status) queryString += '&status=' + status;

  return queryString ? '?' + queryString : queryString;
}

export function offerListFetchData(
  source,
  startDate,
  endDate,
  searchCriteria,
  status,
) {
  const queryString = buildQueryString(
    source,
    startDate,
    endDate,
    searchCriteria,
    status,
  );

  const url = queryString
    ? apiEndPoints.OFFER_LIST + queryString
    : apiEndPoints.OFFER_LIST;
  return (dispatch) => {
    dispatch(offerListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(offerListIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(offerListFetchDataSuccess(items)))
      .catch(() => {
        dispatch(offerListHasErrored(true));
        dispatch(offerListIsLoading(false));
      });
  };
}

export function addNewOfferData(newOffer) {
  const url = apiEndPoints.OFFER_ADD;
  return (dispatch) => {
    dispatch(newOfferIsSaving(true));

    adalApiFetch(fetch, url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(newOffer),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(newOfferIsSaving(false));

        if (response.ok) {
          dispatch(redirectToOfferListPage(true));
        } else {
          switch (response.status) {
            case 422: {
              response.json().then((error) => {
                const items = Object.values(error);
                const message = items.join('; ');
                dispatch(newOfferSaveErrored(true, message));
              });
              break;
            }
            default: {
              response
                .json()
                .then((error) =>
                  dispatch(newOfferSaveErrored(true, error.message)),
                );
              break;
            }
          }
        }
      })
      .catch((response) => {
        // eslint-disable-next-line no-console
        console.log(response);
      });
  };
}

export function editCurrOfferData(newOffer) {
  const url = `${apiEndPoints.OFFER_ADD}/${newOffer.id}`;
  return (dispatch) => {
    dispatch(newOfferIsSaving(true));

    adalApiFetch(fetch, url, {
      method: 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(newOffer),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(newOfferIsSaving(false));

        if (response.ok) {
          dispatch(redirectToOfferListPage(true));
        } else {
          switch (response.status) {
            case 422: {
              response.json().then((error) => {
                const items = Object.values(error);
                const message = items.join('; ');
                dispatch(newOfferSaveErrored(true, message));
              });
              break;
            }
            default: {
              response
                .json()
                .then((error) =>
                  dispatch(newOfferSaveErrored(true, error.message)),
                );
              break;
            }
          }
        }
      })
      .catch((response) => {
        // eslint-disable-next-line no-console
        console.log(response);
      });
  };
}

export function offerDetailsFetchData(offerId) {
  const url = apiEndPoints.OFFER_DETAILS.replace('offerId', offerId);

  return (dispatch) => {
    dispatch(redirectToOfferListPage(false));
    dispatch(offerDetailsIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(offerDetailsIsLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((offerDetails) =>
        dispatch(offerDetailsFetchDataSuccess(offerDetails)),
      )
      .catch(() => dispatch(offerDetailsHasErrored(true)));
  };
}

export function offerRuleFetchData(offerId) {
  const url = apiEndPoints.OFFER_RULES.replace('offerId', offerId);

  return (dispatch) => {
    dispatch(offerDetailsIsLoading(true));
    dispatch(offerRuleFetchDataSuccess([]));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((ruleList) => dispatch(offerRuleFetchDataSuccess(ruleList)))
      .then(() => dispatch(offerDetailsIsLoading(false)))
      .catch(() => dispatch(offerDetailsHasErrored(true)));
  };
}

export function addNewOfferRuleData(offerRule) {
  const url = apiEndPoints.OFFER_RULE_ADD;
  return (dispatch) => {
    dispatch(offerRuleIsSaving(true));
    adalApiFetch(fetch, url, {
      method: 'POST', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(offerRule),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(offerRuleIsSaving(false));
        return response;
      })
      .then((response) => response.json())
      .then((createdOfferRule) => {
        dispatch(addNewOfferRuleDataSuccess(createdOfferRule));
      })
      .then(() => {
        dispatch(offerRuleFetchData(offerRule.OfferId));
      })
      .catch(() => dispatch(offerRuleIsSaveErrored(true)));
  };
}

export function updateOfferRuleData(offerRule) {
  const url = `${apiEndPoints.OFFER_RULE_ADD}/${offerRule.id}`;
  return (dispatch) => {
    dispatch(offerRuleIsSaving(true));

    adalApiFetch(fetch, url, {
      method: 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(offerRule),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(offerRuleIsSaving(false));
        if (!response.ok) {
          response.json().then(function (error) {
            dispatch(offerRuleIsSaveErrored(true, error.message));
          });
          throw Error(response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((offerRule) => {
        dispatch(updateOfferRuleDataSuccess(offerRule));
      })
      .catch((response) => {
        // eslint-disable-next-line no-console
        console.log(response);
      });
  };
}

export function removeOfferRuleData(offerRule, offerId) {
  return (dispatch) => {
    const ruleId = offerRule.id;
    const url = apiEndPoints.OFFER_RULE_DELETE.replace('ruleId', ruleId);
    adalApiFetch(fetch, url, {
      method: 'DELETE', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        //dispatch(offerRuleIsSaving(false));
        return response;
      })
      .then((response) => response.json())
      .then((removedOfferRule) => {
        dispatch(removeOfferRuleDataSuccess(removedOfferRule));
      })
      .then(() => dispatch(offerRuleFetchData(offerId)))
      .catch(() => dispatch(offerRuleIsSaveErrored(true)));
  };
}

export function supplierItemListFetchData() {
  const url = apiEndPoints.SUPPLIER_ITEM_LIST;

  return (dispatch) => {
    dispatch(supplierItemListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(supplierItemListIsLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((supplierIetmList) =>
        dispatch(supplierItemListFetchDataSuccess(supplierIetmList)),
      )
      .catch(() => dispatch(supplierItemListHasErrored(true)));
  };
}

export function ActivateOfferData(offerId) {
  const url = apiEndPoints.OFFER_ACTIVATE.replace('offerId', offerId);
  return (dispatch) => {
    dispatch(activateOfferSaving(true));

    adalApiFetch(fetch, url, {
      method: 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      //body: JSON.stringify(offerRule),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(activateOfferSaving(false));
        if (!response.ok) {
          response.json().then(function () {
            dispatch(activateOfferErrored(true));
          });
          throw Error(response.status);
        }
        return;
      })
      .then(() => {
        dispatch(activateOfferDataSuccess(true));
        dispatch(
          offerListFetchData(null, '01-Jan-2018', '28-Apr-2020', null, null),
        );
      })
      .catch((response) => {
        //eslint-disable-next-line no-console
        console.log(response);
      });
  };
}
